export const DEFAULT_INTERACTIVE_LIST_WIDGET_PMDATA = {
  widthPx: 548,
  heightPx: 159,
  proseMirrorData: {
    type: 'doc',
    content: [
      {
        type: 'table',
        content: [
          {
            type: 'tableRow',
            content: [
              {
                type: 'tableCell',
                attrs: {
                  colspan: 1,
                  rowspan: 1,
                  colwidth: [45.07173422365282],
                  backgroundColor: 'transparent',
                  borderColor: '#000000',
                  borderWidth: '1px',
                  verticalAlignment: 'middle',
                },
                content: [
                  {
                    type: 'paragraph',
                    attrs: {
                      lineHeight: '1.2',
                      textAlign: 'center',
                      fontSize: '16px',
                    },
                    content: [
                      {
                        type: 'checkbox',
                        attrs: {
                          id: '7lACsaTgoRQkBX11VzU88',
                          isChecked: false,
                        },
                      },
                    ],
                  },
                ],
              },
              {
                type: 'tableCell',
                attrs: {
                  colspan: 1,
                  rowspan: 1,
                  colwidth: [502.37695476364297],
                  backgroundColor: 'transparent',
                  borderColor: '#000000',
                  borderWidth: '1px',
                  verticalAlignment: 'top',
                },
                content: [
                  {
                    type: 'paragraph',
                    attrs: {
                      lineHeight: '1.2',
                      textAlign: 'left',
                      fontSize: '16px',
                    },
                    content: [
                      {
                        type: 'text',
                        marks: [
                          {
                            type: 'textStyle',
                            attrs: {
                              fontFamily: 'Inter',
                              fontSize: '16px',
                              color: '#2B2B35',
                            },
                          },
                        ],
                        text: 'New hire paperwork',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            type: 'tableRow',
            content: [
              {
                type: 'tableCell',
                attrs: {
                  colspan: 1,
                  rowspan: 1,
                  colwidth: [45.07173422365282],
                  backgroundColor: 'transparent',
                  borderColor: '#000000',
                  borderWidth: '1px',
                  verticalAlignment: 'middle',
                },
                content: [
                  {
                    type: 'paragraph',
                    attrs: {
                      lineHeight: '1.2',
                      textAlign: 'center',
                      fontSize: '16px',
                    },
                    content: [
                      {
                        type: 'checkbox',
                        attrs: {
                          id: 'PVevMMv_eM6gFxrvp9W7G',
                          isChecked: false,
                        },
                      },
                    ],
                  },
                ],
              },
              {
                type: 'tableCell',
                attrs: {
                  colspan: 1,
                  rowspan: 1,
                  colwidth: [502.37695476364297],
                  backgroundColor: 'transparent',
                  borderColor: '#000000',
                  borderWidth: '1px',
                  verticalAlignment: 'top',
                },
                content: [
                  {
                    type: 'paragraph',
                    attrs: {
                      lineHeight: '1.2',
                      textAlign: 'left',
                      fontSize: '16px',
                    },
                    content: [
                      {
                        type: 'text',
                        marks: [
                          {
                            type: 'textStyle',
                            attrs: {
                              fontFamily: 'Inter',
                              fontSize: '16px',
                              color: '#2B2B35',
                            },
                          },
                        ],
                        text: 'Policy and culture training',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            type: 'tableRow',
            content: [
              {
                type: 'tableCell',
                attrs: {
                  colspan: 1,
                  rowspan: 1,
                  colwidth: [45.07173422365282],
                  backgroundColor: 'transparent',
                  borderColor: '#000000',
                  borderWidth: '1px',
                  verticalAlignment: 'middle',
                },
                content: [
                  {
                    type: 'paragraph',
                    attrs: {
                      lineHeight: '1.2',
                      textAlign: 'center',
                      fontSize: '16px',
                    },
                    content: [
                      {
                        type: 'checkbox',
                        attrs: {
                          id: 'pmxDcWgJzRsYT7iZNZpva',
                          isChecked: false,
                        },
                      },
                    ],
                  },
                ],
              },
              {
                type: 'tableCell',
                attrs: {
                  colspan: 1,
                  rowspan: 1,
                  colwidth: [502.37695476364297],
                  backgroundColor: 'transparent',
                  borderColor: '#000000',
                  borderWidth: '1px',
                  verticalAlignment: 'top',
                },
                content: [
                  {
                    type: 'paragraph',
                    attrs: {
                      lineHeight: '1.2',
                      textAlign: 'left',
                      fontSize: '16px',
                    },
                    content: [
                      {
                        type: 'text',
                        marks: [
                          {
                            type: 'textStyle',
                            attrs: {
                              fontFamily: 'Inter',
                              fontSize: '16px',
                              color: '#2B2B35',
                            },
                          },
                        ],
                        text: 'Job training',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            type: 'tableRow',
            content: [
              {
                type: 'tableCell',
                attrs: {
                  colspan: 1,
                  rowspan: 1,
                  colwidth: [45.07173422365282],
                  backgroundColor: 'transparent',
                  borderColor: '#000000',
                  borderWidth: '1px',
                  verticalAlignment: 'middle',
                },
                content: [
                  {
                    type: 'paragraph',
                    attrs: {
                      lineHeight: '1.2',
                      textAlign: 'center',
                      fontSize: '16px',
                    },
                    content: [
                      {
                        type: 'checkbox',
                        attrs: {
                          id: 'qa_zfD9tQeDXx13WJMETy',
                          isChecked: false,
                        },
                      },
                    ],
                  },
                ],
              },
              {
                type: 'tableCell',
                attrs: {
                  colspan: 1,
                  rowspan: 1,
                  colwidth: [502.37695476364297],
                  backgroundColor: 'transparent',
                  borderColor: '#000000',
                  borderWidth: '1px',
                  verticalAlignment: 'top',
                },
                content: [
                  {
                    type: 'paragraph',
                    attrs: {
                      lineHeight: '1.2',
                      textAlign: 'left',
                      fontSize: '16px',
                    },
                    content: [
                      {
                        type: 'text',
                        marks: [
                          {
                            type: 'textStyle',
                            attrs: {
                              fontFamily: 'Inter',
                              fontSize: '16px',
                              color: '#2B2B35',
                            },
                          },
                        ],
                        text: 'Employee handbook',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            type: 'tableRow',
            content: [
              {
                type: 'tableCell',
                attrs: {
                  colspan: 1,
                  rowspan: 1,
                  colwidth: [45.07173422365282],
                  backgroundColor: 'transparent',
                  borderColor: '#000000',
                  borderWidth: '1px',
                  verticalAlignment: 'middle',
                },
                content: [
                  {
                    type: 'paragraph',
                    attrs: {
                      lineHeight: '1.2',
                      textAlign: 'center',
                      fontSize: '16px',
                    },
                    content: [
                      {
                        type: 'checkbox',
                        attrs: {
                          id: 'sGwHwBE9zH5ORWgTOAb8C',
                          isChecked: false,
                        },
                      },
                    ],
                  },
                ],
              },
              {
                type: 'tableCell',
                attrs: {
                  colspan: 1,
                  rowspan: 1,
                  colwidth: [502.37695476364297],
                  backgroundColor: 'transparent',
                  borderColor: '#000000',
                  borderWidth: '1px',
                  verticalAlignment: 'top',
                },
                content: [
                  {
                    type: 'paragraph',
                    attrs: {
                      lineHeight: '1.2',
                      textAlign: 'left',
                      fontSize: '16px',
                    },
                    content: [
                      {
                        type: 'text',
                        marks: [
                          {
                            type: 'textStyle',
                            attrs: {
                              fontFamily: 'Inter',
                              fontSize: '16px',
                              color: '#2B2B35',
                            },
                          },
                        ],
                        text: 'Team introductions',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};
